import React from 'react'

export interface CartIconProps {
  className?: string
  quantity: number | null
}

const CartIcon: React.VFC<CartIconProps> = ({ className, quantity }) => {
  const quantityText = quantity ? `${quantity < 100 ? quantity : '99+'}` : ''
  return (
    <>
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        role="img"
        aria-label={`Shopping cart${quantity ? ` with ${quantity < 100 ? quantity : '99+'} item${quantity !== 1 ? 's' : ''}` : ''}`}
      >
        <path d="M10.03 21.5933C10.3019 23.0028 9.09348 24.2325 7.64334 23.9625C6.85785 23.8126 6.22341 23.1828 6.07236 22.373C5.80046 20.9635 7.03912 19.7638 8.45905 20.0338C9.24454 20.1837 9.87898 20.8135 10.03 21.5933Z" />
        <path d="M19.0936 21.5933C19.3655 23.0028 18.157 24.2325 16.7069 23.9625C15.9214 23.8126 15.2869 23.1828 15.1359 22.373C14.864 20.9635 16.1026 19.7638 17.4924 20.0338C18.3081 20.1837 18.9425 20.8135 19.0936 21.5933Z" />
        <path d="M22.2959 14.2456L23.9877 5.06842C24.0784 4.52859 23.6554 4.01875 23.0814 4.01875H5.16613C4.86401 4.01875 4.62232 3.80881 4.5619 3.50891L4.35042 1.97938C4.16915 0.899719 3.14197 0 2.02415 0H0.906338C0.392746 0 0 0.389878 0 0.899719V1.10965C0 1.61949 0.392746 2.00937 0.906338 2.00937H1.54077C1.99394 2.00937 2.35648 2.33927 2.44711 2.75914L4.89422 18.2343C4.95465 18.6542 5.3776 18.9841 5.80056 18.9841H21.2687C21.7823 18.9841 22.1751 18.5942 22.1751 18.0844V17.8744C22.1751 17.3646 21.7823 16.9747 21.2687 16.9747H7.49239C7.03922 16.9747 6.67669 16.6448 6.58606 16.2249L6.55584 16.015C6.46521 15.4752 6.88817 14.9653 7.46218 14.9653H21.3896C21.8427 14.9953 22.2053 14.6954 22.2959 14.2456Z" />
      </svg>
      <span className="text-sm">{quantityText}</span>
    </>
  )
}

export default CartIcon
